import { useIntl } from 'react-intl'
import Caption from '../Typography/Caption'
import FormatDecimal from 'components/utils/Formatters/FormatDecimal'
import { loyaltyUnitMessages } from 'constants/config/i18nMessages'

interface Props {
  value: number
  /**
   * @default light-foreground-alt
   */
  colour?: 'light-foreground-alt'
}

function PriceRowPointsSale(props: Props) {
  const { value, colour = 'light-foreground-alt' } = props
  const intl = useIntl()

  return <Caption
    as="s"
    variant="medium"
    colour={colour}
  >
    {intl.formatMessage(
      {
        id: '_HAS4DfBTrR8pJ3VsQJl',
        defaultMessage: 'Was {points}{unit}',
        description: 'Strikethrough points sale label showing previous points amount',
      },
      {
        points: <FormatDecimal value={value} />,
        unit: intl.formatMessage(loyaltyUnitMessages.pointsAbbreviationPlural),
      },
    )}
  </Caption>
}

export default PriceRowPointsSale
